/**
 * A grid pane comes in two densities (see .data-grid--pane.is-roomy in
 * _dashboard.scss). Roomy -- taller rows, more space around the header, the
 * bulk bar and the footer -- for as long as the page of rows fits without
 * scrolling at that size, so a short list isn't squeezed into a strip.
 * Compact once it would have to scroll, so a long list shows all it can.
 */

const fitGridDensity = (pane, scroller) => {

  if (!pane || !scroller) {
    return;
  }

  pane.classList.add('is-roomy');

  // a pixel of slack for fractional row heights
  if (scroller.scrollHeight > scroller.clientHeight + 1) {
    pane.classList.remove('is-roomy');
  }

};

/**
 * Keeps a pane's density in step with the room it has.
 *
 * @param {HTMLElement} pane      the .data-grid--pane
 * @param {HTMLElement} scroller  its .data-grid__grid-container
 * @param {HTMLElement} room      the box whose height is what the pane may
 *   grow to. It is watched rather than the pane itself, whose own size changes
 *   with the density: the window, the menu or a site message resizes it.
 * @returns {Function} fit -- call it whenever the pane has been redrawn
 */
const watchGridDensity = (pane, scroller, room) => {

  const fit = () => fitGridDensity(pane, scroller);

  if (window.ResizeObserver && room) {
    new ResizeObserver(fit).observe(room);
  } else {
    window.addEventListener('resize', fit);
  }

  return fit;

};

export default watchGridDensity;
